import React from "react";

function FilterTab(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 4 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4 44C1.79086 44 0 42.2091 0 40L0 4C0 1.79086 1.79086 0 4 0L4 44Z"
        fill="#6E00BE"
      />
    </svg>
  );
}

const MemoFilterIcon = React.memo(FilterTab);
export default MemoFilterIcon;
